import styled, { css } from 'styled-components';
import { colors, elevation } from 'bench-style-constants';
import { ReactNode } from 'react';

type CardProps = {
  centered?: boolean;
  children: ReactNode;
  elevation?: 0 | 1 | 2 | 3;
  ghost?: boolean;
};

const Card = styled.div<CardProps>`
  background-color: ${colors.white};
  border-radius: 0.5rem;
  display: block;
  padding: 16px 24px;

  ${props =>
    props.elevation === 1 &&
    css`
      box-shadow: ${elevation.level1};
    `}

  ${props =>
    props.elevation === 2 &&
    css`
      box-shadow: ${elevation.level2};
    `}

  ${props =>
    props.elevation === 3 &&
    css`
      box-shadow: ${elevation.level3};
    `}

  ${props =>
    props.ghost &&
    css`
      background: ${colors.shell};
      box-shadow: none;
    `}
`;

export default Card;
